
(function () {
  'use strict';
 
  var STANDAARD = {
    technieken: {
      /* Maten komen uit de prijslijst van Screen Group 2026. minAantal is ons
         eigen commerciële minimum (25 per drukklus), niet dat van de drukker. */
      zeefdruk: { naam: 'Zeefdruk', maxBreedteMm: 360, maxHoogteMm: 460, minAantal: 25 },
      transfer: { naam: 'Transfer', maxBreedteMm: 300, maxHoogteMm: 330, minAantal: 25 },
      borduren: { naam: 'Borduren', maxBreedteMm: 280, maxHoogteMm: 280, minAantal: 25 },
      dtg: { naam: 'DTG', maxBreedteMm: 280, maxHoogteMm: 400, minAantal: 25 }
    },
    /**
     * De klant kiest bedrukken of borduren; welke druktechniek dat wordt kiezen
     * wij. Onze drukker doet zeefdruk pas vanaf 50 stuks, daaronder is het
     * protransfer — en dat heeft een kleiner drukvlak. Daarom hangt de techniek
     * aan het aantal, en niet aan een keuzemenu waar de klant niets aan heeft.
     */
    keuzes: {
      bedrukken: { naam: 'Bedrukken', vanaf50: 'zeefdruk', onder50: 'transfer' },
      borduren: { naam: 'Borduren', vanaf50: 'borduren', onder50: 'borduren' }
    },
    /**
     * De staffel is een korting per stuk op de catalogusprijs, precies zoals de
     * automatische kortingen in Shopify. Daardoor klopt de richtprijs hier voor
     * élk artikel, van een tote bag tot een winterjas — de module hoeft geen
     * eigen prijslijst bij te houden.
     */
    staffel: [
      { vanaf: 250, korting: 3.30 },
      { vanaf: 100, korting: 2.55 },
      { vanaf: 50, korting: 1.00 },
      { vanaf: 25, korting: 0 }
    ],
    insteltarief: 35,
    minDpi: 150
  };
 
  /* Plaatsingen zijn verschuivingen ten opzichte van het gekalibreerde
     drukvlak op de foto: xMm vanaf het midden, yMm vanaf de bovenrand. */
  var PLAATSINGEN = {
    front: { naam: 'Front gecentreerd', xMm: 0, yMm: 0, breedteMm: 360, hoogteMm: 460 },
    borst: { naam: 'Borst links', xMm: -95, yMm: 10, breedteMm: 100, hoogteMm: 100 },
    rug: { naam: 'Rug gecentreerd', xMm: 0, yMm: 0, breedteMm: 360, hoogteMm: 460 }
  };
 
  /**
   * Artikelen waarop niet alles kan. Opgave drukker, 01-10-2026.
   *
   * Op een muts past geen zeefdruk en geen drukvlak van 36 bij 46 centimeter.
   * Zonder deze tabel tekent de module voor élk artikel het maximum van een
   * shirt, en dat liep bij een tote bag onder de tas door.
   *
   *   technieken  welke technieken de drukker hierop aankan
   *   vlak        maximaal drukvlak in millimeter
   *   breedteMm   werkelijke breedte van het artikel, als maatstok voor de foto
   *   bovenPct    waar de druk begint, als deel van de hoogte van het artikel.
   *               Bij kleding rekenen we 170 mm onder het schouderpunt; op een
   *               muts of een tas bestaat dat punt niet, dus zetten we het hier
   *               rechtstreeks. Dit zijn schattingen tot de proefdruk van Screen
   *               Holland terug is.
   *   linksPct    verschuiving vanaf het hart van het artikel, als deel van de
   *               maatstok. Alleen nodig waar de druk niét in het midden hoort:
   *               op een broek staat het logo op één pijp.
   *
   * Staat een artikel hier niet in, dan gelden de gewone maten.
   */
  var ARTIKELREGELS = {
    /* Mutsen — alleen borduren, en alles blíjft op de omslag.
     *
     * Over de vouw van de omslag kan niet gewerkt worden: daar liggen twee
     * lagen brei over elkaar en loopt de naald door een rand. De druk moet er
     * dus helemaal onder blijven, niet half.
     *
     * De vouwlijn is op 07-10-2026 per muts opgemeten: in de middenbaan van de
     * packshot is gezocht naar de sterkste horizontale rand in de onderste
     * helft. Die ligt op 0,70 (Rib Beanie 2.0 en Fisherman Beanie) en 0,75
     * (Rib Beanie) van de hoogte. Daaronder is nog ongeveer 55 mm omslag; een
     * vlak van 50 mm vulde dat van rand tot rand. Vandaar 40 mm, midden op de
     * omslag gezet, met marge boven en onder.
     *
     * Van de Fisherman Beanie 2.0 (STAU296) is geen packshot in Bestanden, in
     * geen enkele kleur. Die krijgt de maten van zijn naamgenoot STAU771.
     */
    STAU295: { technieken: ['borduren'], vlak: { breedteMm: 100, hoogteMm: 40 }, breedteMm: 200, bovenPct: 0.74 },
    STAU296: { technieken: ['borduren'], vlak: { breedteMm: 100, hoogteMm: 40 }, breedteMm: 200, bovenPct: 0.74 },
    STAU771: { technieken: ['borduren'], vlak: { breedteMm: 100, hoogteMm: 40 }, breedteMm: 200, bovenPct: 0.74 },
    STAU772: { technieken: ['borduren'], vlak: { breedteMm: 100, hoogteMm: 40 }, breedteMm: 200, bovenPct: 0.76 },
    /* Bucket Hat — geen omslag maar een rand. Het borduursel gaat op de zijkant
       van de bol, tussen de naad bovenaan en de naad waar de rand begint. */
    STAU893: { technieken: ['borduren'], vlak: { breedteMm: 90, hoogteMm: 35 }, breedteMm: 200, bovenPct: 0.42 },
    /* Pet met vijf panelen — transfer mag hier wel */
    STAU297: { technieken: ['transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 50 }, breedteMm: 200, bovenPct: 0.25 },
    /* Katoenen tassen — groot vlak, zeefdruk mag */
    STAU116: { technieken: ['zeefdruk', 'transfer'], vlak: { breedteMm: 280, hoogteMm: 280 }, breedteMm: 380, bovenPct: 0.18 },
    STAU117: { technieken: ['zeefdruk', 'transfer'], vlak: { breedteMm: 280, hoogteMm: 280 }, breedteMm: 420, bovenPct: 0.06 },
    STAU760: { technieken: ['zeefdruk', 'transfer'], vlak: { breedteMm: 280, hoogteMm: 280 }, breedteMm: 380, bovenPct: 0.18 },
    STAU773: { technieken: ['zeefdruk', 'transfer'], vlak: { breedteMm: 280, hoogteMm: 280 }, breedteMm: 380, bovenPct: 0.18 },
    /* Polyester tassen — alleen transfer */
    STAU763: { technieken: ['transfer'], vlak: { breedteMm: 280, hoogteMm: 280 }, breedteMm: 380, bovenPct: 0.18 },
    STAU892: { technieken: ['transfer'], vlak: { breedteMm: 150, hoogteMm: 100 }, breedteMm: 500, bovenPct: 0.3 },
    STAU891: { technieken: ['transfer'], vlak: { breedteMm: 100, hoogteMm: 40 }, breedteMm: 340, bovenPct: 0.3 },
    /* Slab — dubbele stof */
    STAU029: { technieken: ['transfer', 'borduren'], vlak: { breedteMm: 150, hoogteMm: 150 }, breedteMm: 240, bovenPct: 0.25 },

    /* ---------------------------------------------------------- broeken ---
     *
     * Op een broek kan niet in het midden gedrukt worden. Daar zit het kruis:
     * vier naden die samenkomen, en de twee pijpen liggen er niet vlak. De
     * drukker legt één pijp op de tafel en drukt daarop - standaard links, net
     * onder het kruis, waar de stof één laag dik is en vlak ligt.
     *
     * De getallen komen uit de packshots zelf, opgemeten op 07-10-2026. Per
     * broek is het silhouet uitgelezen en is gezocht naar de rij waar het in
     * twee losse stukken uiteenvalt: dat is het kruis. Opvallend eenduidig:
     *
     *   pijpbreedte   0,46 tot 0,48 van de breedte van het kledingstuk
     *   hart pijp     0,24 tot 0,26 vanaf de linkerrand - dus linksPct -25
     *   kruis         0,30 (Mover Vintage) tot 0,69 (Boarder Dry, een short)
     *
     * Bij een lange broek staat bovenPct vier procent ónder het gemeten kruis
     * en is het drukvlak 100 bij 120 mm; een pijp is in het echt ongeveer
     * 200 mm breed, dus dat past ruim.
     *
     * Bij een short is daar geen plek: onder het kruis zit nog maar een hand
     * breed stof. Daar gaat de druk er juist bovenlangs, op het linkervoorpand
     * naast de middennaad, en is het vlak 90 bij 90 mm. Nagemeten op de
     * Boarder Dry: de onderkant van het vlak komt dan op 0,62 van de hoogte
     * en het kruis zit op 0,69.
     *
     * De Needer en de Barreler zijn er op 07-10 bij gekomen, zodra hun packshot
     * in Bestanden stond. Die twee hebben een dichte achtergrond, dus daar komt
     * het silhouet uit de randvulling; gemeten kruis 0,41 en 0,46.
     */
    STBU157: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 120 }, breedteMm: 420, bovenPct: 0.47, linksPct: -25 }, /* Jammer Dry */
    STBU944: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 90, hoogteMm: 90 }, breedteMm: 420, bovenPct: 0.40, linksPct: -25 }, /* Boarder Dry, short */
    STBU186: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 90, hoogteMm: 90 }, breedteMm: 420, bovenPct: 0.40, linksPct: -25 }, /* Trainer 2.0, short */
    STBU576: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 120 }, breedteMm: 420, bovenPct: 0.34, linksPct: -25 }, /* Mover Vintage */
    STBU185: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 120 }, breedteMm: 420, bovenPct: 0.41, linksPct: -25 }, /* Mover 2.0 */
    STBU274: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 120 }, breedteMm: 420, bovenPct: 0.45, linksPct: -24 }, /* Needer */
    STBU276: { technieken: ['zeefdruk', 'transfer', 'borduren'], vlak: { breedteMm: 100, hoogteMm: 120 }, breedteMm: 420, bovenPct: 0.50, linksPct: -24 }  /* Barreler */
    /* STAU764 Pencil Case: drukvlak nog niet opgegeven door onze drukker. */
  };

  /** Boven dit oppervlak rekent onze drukker op aanvraag, niet op tarief. */
  var MAX_OPPERVLAK_CM2 = 500;

  /**
   * Over de kangoeroezak kan niet gedrukt worden.
   *
   * De zak zit met een naad aan het voorpand en ligt daar als dubbele stof
   * overheen. Een drukraam of een transferpers wil een vlakke ondergrond; loopt
   * de naad onder de druk door, dan krijg je een vouw of een onderbreking in de
   * inkt. De drukker houdt er daarom minimaal twee centimeter van weg.
   *
   * ZAK_FRACTIE is waar de bovenrand van de zak ligt, uitgedrukt als deel van
   * de afstand tussen de schouderlijn en de zoom. Dat is geen schatting: op
   * 07-10-2026 is de zaklijn op alle achttien hoodies in de catalogus
   * opgemeten, door in de middenbaan van de packshot de horizontale randen te
   * zoeken. De gevonden lijn lag tussen 0,58 en 0,64. We houden 0,56 aan, net
   * boven de laagste meting - bij twijfel liever een paar millimeter minder
   * drukvlak dan een druk die de naad raakt.
   *
   * Omdat we met een fractie van de fóto rekenen en niet met millimeters,
   * klopt de grens ook als de maatstok van een artikel nog niet gekalibreerd
   * is: de lijn ligt op de goede plek op de packshot, wat die foto ook meet.
   */
  var ZAK_FRACTIE = 0.56;
  var ZAK_MARGE_MM = 20;

  /**
   * Welke artikelen hebben die zak?
   *
   * Eerst kijken we in de kenmerken die Stanley/Stella bij het artikel levert:
   * staat daar "kangoeroezak", dan is het zeker. Dat is de betrouwbaarste bron
   * die we hebben - betrouwbaarder dan de foto en betrouwbaarder dan de soort.
   *
   * Maar de kenmerkenlijst is niet overal even volledig; bij de garment-dyed
   * lijn ontbreekt hij soms. Daarom geldt daarnaast de soort: élke hoodie
   * krijgt de grens, ook als er niets vermeld staat. Een hoodie zonder zak
   * levert dan een paar centimeter drukhoogte in die hij eigenlijk had mogen
   * gebruiken; andersom levert het een mislukte druk op.
   */
  var ZAK_SOORTEN = ['hoodies'];

  /**
   * Een rits over het hele voorpand.
   *
   * Daar kan geen gecentreerde frontdruk op: de rits loopt er middendoor en de
   * twee panden liggen niet in één vlak. De drukker doet op zo'n artikel een
   * borstdruk naast de rits, of de rug.
   *
   * Stanley/Stella beschrijft dit in de kenmerken altijd met het woord
   * "middenvoor" erbij - "nylon rits middenvoor", "waterdichte rits
   * middenvoor". Een zakrits, een binnenzak of een rits in de zijnaad heeft dat
   * woord niet. Op die twee woorden samen draait de regel.
   *
   * Ook een kwartrits en een korte rits tellen mee. Die lopen van de kraag tot
   * ongeveer het borstbeen - precies de hoogte waar een frontdruk begint. De
   * twee artikelen die het betreft (Proper, Trucker 2.0) houden hun borstdruk
   * en hun rugdruk; dat is een paar centimeter drukvlak minder dan strikt
   * nodig, tegenover een naad middenin de druk als we het niet doen.
   */
  function heeftVolleRits(kenmerken) {
    for (var i = 0; i < kenmerken.length; i++) {
      var r = kenmerken[i];
      if (r.indexOf('rits') === -1) continue;
      if (r.indexOf('middenvoor') === -1) continue;
      return true;
    }
    return false;
  }

  function euro(n) { return '€ ' + Number(n).toFixed(2).replace('.', ','); }
 
  function mediaan(a) {
    var b = a.slice().sort(function (x, y) { return x - y; });
    return b[Math.floor(b.length / 2)];
  }

  /**
   * Silhouet zoeken in een foto zonder transparante achtergrond.
   *
   * Stanley/Stella levert twee soorten packshots. De meeste hebben een
   * transparante achtergrond; dan is het alfakanaal het silhouet. Maar een deel
   * van het assortiment - de garment-dyed lijn en de jassen - komt als dichte
   * PNG op een egale achtergrond. Daar zegt het alfakanaal niets: elke pixel is
   * dekkend, en het "kledingstuk" lijkt dan de hele foto.
   *
   * Hier vullen we vanaf de vier randen de achtergrondkleur weg, zoals de
   * emmer in een tekenprogramma. Wat niet bereikt wordt, is het kledingstuk.
   * Vullen vanaf de rand en niet simpelweg "alles wat op de achtergrondkleur
   * lijkt", zodat een witte broekband midden op een wit shirt niet ineens
   * achtergrond wordt.
   */
  function silhouetUitAchtergrond(d, breed, hoog) {
    var rs = [], gs = [], bs = [], i;
    function randpunt(x, y) {
      i = (y * breed + x) * 4;
      rs.push(d[i]); gs.push(d[i + 1]); bs.push(d[i + 2]);
    }
    for (var x0 = 0; x0 < breed; x0++) { randpunt(x0, 0); randpunt(x0, hoog - 1); }
    for (var y0 = 0; y0 < hoog; y0++) { randpunt(0, y0); randpunt(breed - 1, y0); }
    var ar = mediaan(rs), ag = mediaan(gs), ab = mediaan(bs);

    var TOLERANTIE = 90; // som over r, g en b - ruim genoeg voor de zachte slagschaduw
    var achter = new Uint8Array(breed * hoog);
    var stapel = [];
    function duw(x, y) {
      if (x < 0 || y < 0 || x >= breed || y >= hoog) return;
      var p = y * breed + x;
      if (achter[p]) return;
      var j = p * 4;
      if (Math.abs(d[j] - ar) + Math.abs(d[j + 1] - ag) + Math.abs(d[j + 2] - ab) > TOLERANTIE) return;
      achter[p] = 1;
      stapel.push(p);
    }
    for (var x1 = 0; x1 < breed; x1++) { duw(x1, 0); duw(x1, hoog - 1); }
    for (var y1 = 0; y1 < hoog; y1++) { duw(0, y1); duw(breed - 1, y1); }
    while (stapel.length) {
      var p2 = stapel.pop();
      var px = p2 % breed, py = (p2 - px) / breed;
      duw(px + 1, py); duw(px - 1, py); duw(px, py + 1); duw(px, py - 1);
    }

    var masker = new Uint8Array(breed * hoog);
    for (var q = 0; q < masker.length; q++) masker[q] = achter[q] ? 0 : 1;
    return masker;
  }

  /**
   * Waar ligt de schouderlijn in het silhouet?
   *
   * Bij een T-shirt begint het kledingstuk meteen op de schouder: de bovenrand
   * van de packshot ís het hoogste schouderpunt. Bij een hoodie zit daar eerst
   * een capuchon boven, bij een polo een kraag en bij een tas een paar hengsels.
   *
   * Niet de breedte zelf verraadt de schouder, maar de verándering ervan. Een
   * T-shirt met wijde mouwen wordt van de schouder af gestaag breder: steile
   * helling, maar gelijkmatig. Bij een capuchon of hengsels is de vorm eerst
   * smal en flauw, en op de schouderlijn knikt hij. We zoeken dus de grootste
   * versnelling - helling nu min helling zes rijen hoger - en niet de grootste
   * toename.
   *
   * De eerste rijen slaan we over: op de bovenrand gaat het silhouet in één keer
   * van niets naar stof, en die harde rand zou elke knik overstemmen.
   *
   * Knikt er niets noemenswaardigs, dan ís de bovenrand de schouder. Zo werkt
   * dezelfde regel voor een shirt, een hoodie, een muts en een tas, zonder dat
   * we hoeven te weten wat voor artikel het is.
   *
   * @param {function(number): number} breedteVanRij  breedte van het silhouet op rij y
   * @param {number} minY  bovenrand van het kledingstuk
   * @param {number} maxY  onderrand van het kledingstuk
   * @param {number} lichaamPx  gemeten lichaamsbreedte, als maat voor "noemenswaardig"
   * @returns {number} rij van de schouderlijn
   */
  function schouderlijn(breedteVanRij, minY, maxY, lichaamPx) {
    var hoogte = maxY - minY + 1;
    var van = minY + Math.max(4, Math.round(hoogte * 0.06));
    var tot = minY + Math.round(hoogte * 0.45);
    var helling = function (y) {
      return breedteVanRij(Math.min(y + 1, maxY)) - breedteVanRij(Math.max(y - 2, minY));
    };
    var besteY = minY;
    var beste = 0;
    for (var y = van; y <= tot; y++) {
      var versnelling = helling(y) - helling(Math.max(y - 6, minY));
      if (versnelling > beste) { beste = versnelling; besteY = y; }
    }
    var drempel = Math.max(3, (lichaamPx || 0) * 0.05);
    return beste >= drempel ? besteY : minY;
  }
 
  function handleize(t) {
    return String(t || '').toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
 
  function Module(wortel) {
    var gegevens = wortel.querySelector('[data-rockland-gegevens]');
    if (!gegevens) return;
 
    this.wortel = wortel;
    this.shop = JSON.parse(gegevens.textContent);
    this.specs = STANDAARD;
    this.bezig = false;
    this.fotos = {};
    this.gekozen = {};
 
    var donker = String(this.shop.donkereKleuren || '').split(',').map(handleize).filter(Boolean);
    this.shop.kleuren = (this.shop.kleuren || []).map(function (k) {
      k.donker = donker.indexOf(handleize(k.naam)) !== -1;
      return k;
    });
 
    this.staat = {
      kleur: null, bestand: null, afbeelding: null, vector: false,
      natBreedte: 0, natHoogte: 0, breedteMm: 180, rotatie: 0,
      xMm: 0, yMm: 0, aantallen: {}, drukkleur: ''
    };
 
    this.verbind();
    this.controleerRits();
    this.luisterNaarThema();
    this.haalSpecificaties();
    var eersteBestelbaar = null;
    for (var i = 0; i < this.shop.kleuren.length; i++) {
      if (this.shop.kleuren[i].bestelbaar !== false) { eersteBestelbaar = this.shop.kleuren[i]; break; }
    }
    this.kiesKleur(eersteBestelbaar || this.shop.kleuren[0]);
    this.werkBij();
  }
 
  /* ------------------------------------------------------------ opbouw --- */
 
  Module.prototype.verbind = function () {
    var w = this.wortel, zelf = this;
    var q = function (s) { return w.querySelector(s); };
 
    this.podium = q('[data-rockland-podium]');
    this.canvas = q('[data-rockland-canvas]');
    this.ctx = this.canvas.getContext('2d');
    this.meting = q('[data-rockland-meting]');
    this.kiezer = q('[data-rockland-kiezer]');
    this.bestandsnaam = q('[data-rockland-bestandsnaam]');
    this.invoer = q('[data-rockland-bestand]');
    this.schuifBreedte = q('[data-rockland-breedte]');
    this.uitBreedte = q('[data-rockland-breedte-uit]');
    this.schuifRotatie = q('[data-rockland-rotatie]');
    this.uitRotatie = q('[data-rockland-rotatie-uit]');
    this.keuzeTechniek = q('[data-rockland-techniek]');
    this.keuzePlaatsing = q('[data-rockland-plaatsing]');
    this.veldDrukkleur = q('[data-rockland-drukkleur]');
    this.matenVak = q('[data-rockland-maten]');
    this.kleurenVak = q('[data-rockland-kleuren]');
    this.meldingen = q('[data-rockland-meldingen]');
    this.knop = q('[data-rockland-toevoegen]');
    this.uitAantal = q('[data-rockland-aantal]');
    this.uitPerStuk = q('[data-rockland-perstuk]');
    this.uitTotaal = q('[data-rockland-totaal]');
    this.tredesVak = q('[data-rockland-tredes]');
 
    this.bouwKleuren();
    this.bouwMaten();
 
    this.kiezer.addEventListener('click', function () { zelf.invoer.click(); });
    this.kiezer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); zelf.invoer.click(); }
    });
    this.invoer.addEventListener('change', function () { zelf.laadBestand(this.files[0]); });
 
    ['dragenter', 'dragover'].forEach(function (t) {
      zelf.kiezer.addEventListener(t, function (e) { e.preventDefault(); zelf.kiezer.classList.add('rockland__kiezer--over'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      zelf.kiezer.addEventListener(t, function (e) { e.preventDefault(); zelf.kiezer.classList.remove('rockland__kiezer--over'); });
    });
    this.kiezer.addEventListener('drop', function (e) { zelf.laadBestand(e.dataTransfer.files[0]); });
 
    this.schuifBreedte.addEventListener('input', function () {
      zelf.staat.breedteMm = parseInt(this.value, 10);
      zelf.werkBij();
    });
    this.schuifRotatie.addEventListener('input', function () {
      zelf.staat.rotatie = parseInt(this.value, 10);
      zelf.werkBij();
    });
    this.keuzeTechniek.addEventListener('change', function () { zelf.werkBij(); });
    this.keuzePlaatsing.addEventListener('change', function () { zelf.laadFoto(); zelf.centreer(); });
    if (this.veldDrukkleur) {
      this.veldDrukkleur.addEventListener('input', function () { zelf.staat.drukkleur = this.value; });
    }
 
    w.querySelector('[data-rockland-centreren]').addEventListener('click', function () { zelf.centreer(); });
    w.querySelector('[data-rockland-vullend]').addEventListener('click', function () { zelf.vullend(); });
    w.querySelector('[data-rockland-wissen]').addEventListener('click', function () {
      zelf.staat.afbeelding = null;
      zelf.staat.bestand = null;
      zelf.bestandsnaam.textContent = 'Sleep je logo hierheen';
      zelf.werkBij();
    });
 
    this.knop.addEventListener('click', function () { zelf.voegToe(); });
 
    this.canvas.addEventListener('pointerdown', this.pakVast.bind(this));
    this.canvas.addEventListener('pointermove', this.versleep.bind(this));
    this.canvas.addEventListener('pointerup', this.laatLos.bind(this));
    this.canvas.addEventListener('pointercancel', this.laatLos.bind(this));
  };
 
  Module.prototype.bouwKleuren = function () {
    var zelf = this;
    this.kleurenVak.innerHTML = '';
    this.kleurnaamVeld = this.wortel.querySelector('[data-rockland-kleurnaam]');
 
    this.shop.kleuren.forEach(function (kleur) {
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'rockland__kleur';
      knop.setAttribute('aria-label', kleur.naam);
      knop.setAttribute('aria-pressed', 'false');
 
      knop.title = kleur.naam;
      kleur.knop = knop;
      knop.addEventListener('click', function () { zelf.kiesKleur(kleur); });
      knop.addEventListener('mouseenter', function () { zelf.toonKleurnaam(kleur.naam); });
      zelf.kleurenVak.appendChild(knop);
      zelf.verfVlakje(knop, kleur);
    });
 
    this.kleurenVak.addEventListener('mouseleave', function () { zelf.toonKleurnaam(null); });
  };
 
  Module.prototype.toonKleurnaam = function (naam) {
    if (!this.kleurnaamVeld) return;
    this.kleurnaamVeld.textContent = naam || (this.staat.kleur ? this.staat.kleur.naam : '');
  };
 
  /**
   * Geeft het vlakje de kleur van de stof, gemeten uit de packshot. Zo hoeft er
   * nergens een lijst met hexcodes bijgehouden te worden.
   */
  Module.prototype.verfVlakje = function (knop, kleur) {
    var lijst = (kleur.bronnen || []).slice();
    if (kleur.foto) lijst.unshift(kleur.foto);
    if (kleur.fallback) lijst.push(kleur.fallback);
    if (!lijst.length) {
      knop.style.background = kleur.donker ? '#1B1B1B' : '#DDD';
      return;
    }
    probeer(0, true);
 
    function probeer(i, metCors) {
      if (i >= lijst.length) return;
      var img = new Image();
      if (metCors) img.crossOrigin = 'anonymous';
      img.onload = function () {
        var hex = stofkleur(img);
        if (hex) knop.style.background = hex;
        else {
          knop.style.backgroundImage = 'url(' + lijst[i] + ')';
          knop.style.backgroundPosition = 'center 30%';
        }
      };
      img.onerror = function () {
        if (metCors) { probeer(i, false); return; }
        probeer(i + 1, true);
      };
      img.src = lijst[i];
    }
 
    function stofkleur(img) {
      try {
        var b = 48;
        var h = Math.max(1, Math.round(b * (img.naturalHeight / img.naturalWidth)));
        var doek = document.createElement('canvas');
        doek.width = b; doek.height = h;
        var c = doek.getContext('2d', { willReadFrequently: true });
        c.drawImage(img, 0, 0, b, h);
        var d = c.getImageData(0, 0, b, h).data;
        var rs = [], gs = [], bs = [];
        for (var y = Math.round(h * 0.35); y < Math.round(h * 0.7); y++) {
          for (var x = Math.round(b * 0.3); x < Math.round(b * 0.7); x++) {
            var i = (y * b + x) * 4;
            if (d[i + 3] < 230) continue;
            rs.push(d[i]); gs.push(d[i + 1]); bs.push(d[i + 2]);
          }
        }
        if (rs.length < 20) return null;
        return '#' + [mid(rs), mid(gs), mid(bs)].map(function (n) {
          return ('0' + n.toString(16)).slice(-2);
        }).join('');
      } catch (e) {
        return null;
      }
    }
 
    function mid(a) { a.sort(function (x, y) { return x - y; }); return a[Math.floor(a.length / 2)]; }
  };
 
  Module.prototype.bouwMaten = function () {
    var zelf = this;
    this.matenVak.innerHTML = '';
    this.shop.maten.forEach(function (maat) {
      zelf.staat.aantallen[maat] = 0;
      var vak = document.createElement('label');
      vak.className = 'rockland__maat';
      vak.innerHTML = '<span>' + maat + '</span>' +
        '<input type="number" min="0" value="0" data-maat="' + maat + '" aria-label="Aantal ' + maat + '">' +
        '<span class="rockland__voorraad" data-voorraad="' + maat + '"></span>';
      zelf.matenVak.appendChild(vak);
    });
    this.matenVak.addEventListener('input', function (e) {
      var maat = e.target.getAttribute('data-maat');
      if (!maat) return;
      var n = parseInt(e.target.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      var variant = zelf.variantVoor(zelf.staat.kleur, maat);
      if (variant && variant.voorraadBeheerd && n > variant.voorraad) {
        n = Math.max(0, variant.voorraad);
        e.target.value = n;
        /* Zonder de voorraad in beeld is stil terugzetten verwarrend: zeg het. */
        zelf.staat.voorraadgrens = { maat: maat, aantal: n };
      } else if (zelf.staat.voorraadgrens && zelf.staat.voorraadgrens.maat === maat) {
        zelf.staat.voorraadgrens = null;
      }
      zelf.staat.aantallen[maat] = n;
      e.target.setAttribute('value', n);
      zelf.werkBij();
    });
  };
 
  Module.prototype.haalSpecificaties = function () {
    var zelf = this;
    fetch(this.shop.proxy + '/api/specificaties', { headers: { Accept: 'application/json' } })
      .then(function (a) { return a.ok ? a.json() : null; })
      .then(function (s) {
        if (!s) return;
        if (s.technieken) zelf.specs.technieken = s.technieken;
        if (s.staffel) zelf.specs.staffel = s.staffel;
        if (s.insteltarief) zelf.specs.insteltarief = s.insteltarief;
        if (s.bestand && s.bestand.minDpi) zelf.specs.minDpi = s.bestand.minDpi;
        zelf.werkBij();
      })
      .catch(function () {});
  };
 
  /* ----------------------------------------------------------- gegevens --- */
 
  /**
   * De techniekcode die we aan de drukker doorgeven. Bedrukken wordt zeefdruk
   * vanaf 50 stuks en protransfer daaronder; het drukvlak krimpt dan mee, want
   * protransfer kan 300 x 330 mm waar zeefdruk 360 x 460 mm haalt. De klant
   * hoeft dat niet te weten, maar zijn logo moet er wél binnen passen.
   */
  /**
   * De regel voor dít artikel, als die er is. De artikelcode zijn de eerste
   * zeven tekens van de SKU: STAU116C002OS -> STAU116.
   */
  Module.prototype.artikelRegel = function () {
    var code = String(this.shop.artikelcode || '').toUpperCase().slice(0, 7);
    return ARTIKELREGELS[code] || null;
  };

  Module.prototype.techniekCode = function (aantal) {
    var keuze = this.specs.keuzes[this.keuzeTechniek.value] || this.specs.keuzes.bedrukken;
    if (typeof aantal !== 'number') aantal = this.totaal();
    var code = aantal >= 50 ? keuze.vanaf50 : keuze.onder50;
    /* Kan de drukker deze techniek niet op dit artikel - geen zeefdruk op een
       muts - dan pakken we de eerste die hij wél aankan. De klant kiest immers
       bedrukken of borduren, niet de techniek zelf. */
    var regel = this.artikelRegel();
    if (regel && regel.technieken.indexOf(code) === -1) {
      var zelfdeFamilie = (code === 'borduren') ? 'borduren' : null;
      if (zelfdeFamilie && regel.technieken.indexOf(zelfdeFamilie) !== -1) return zelfdeFamilie;
      return regel.technieken[0];
    }
    return code;
  };
  Module.prototype.techniek = function (aantal) {
    return this.specs.technieken[this.techniekCode(aantal)] || this.specs.technieken.transfer;
  };
  /**
   * De plaatsing, maar nooit groter dan wat op dit artikel past. Een tote bag
   * kan bij onze drukker maximaal 280 x 280 mm, een shirt 360 x 460.
   */
  Module.prototype.plaatsing = function () {
    var p = PLAATSINGEN[this.keuzePlaatsing.value] || PLAATSINGEN.front;
    var k = this.shop.drukvlak || {};
    var regel = this.artikelRegel();
    var maxB = k.maxBreedteMm || 0;
    var maxH = k.maxHoogteMm || 0;
    if (regel) {
      maxB = maxB ? Math.min(maxB, regel.vlak.breedteMm) : regel.vlak.breedteMm;
      maxH = maxH ? Math.min(maxH, regel.vlak.hoogteMm) : regel.vlak.hoogteMm;
    }
    /* De zak van een hoodie. Geen maximum uit een tabel maar een grens die uit
       de foto zelf komt; zie zakRuimteMm(). */
    var zak = this.zakRuimteMm();
    var doorZak = false;
    if (zak) {
      doorZak = zak < p.hoogteMm && (!maxH || zak < maxH);
      maxH = maxH ? Math.min(maxH, zak) : zak;
    }
    if (!maxB && !maxH) return p;
    return {
      naam: p.naam, xMm: p.xMm, yMm: p.yMm,
      breedteMm: Math.min(p.breedteMm, maxB || p.breedteMm),
      hoogteMm: Math.min(p.hoogteMm, maxH || p.hoogteMm),
      doorZak: doorZak
    };
  };
  Module.prototype.hoogteMm = function () {
    if (!this.staat.afbeelding || !this.staat.natBreedte) return 0;
    return this.staat.breedteMm * (this.staat.natHoogte / this.staat.natBreedte);
  };
  Module.prototype.variantVoor = function (kleur, maat) {
    if (!kleur) return null;
    for (var i = 0; i < this.shop.varianten.length; i++) {
      var v = this.shop.varianten[i];
      if (v.kleur === kleur.naam && v.maat === maat) return v;
    }
    return null;
  };
  Module.prototype.totaal = function () {
    var t = 0;
    for (var m in this.staat.aantallen) t += this.staat.aantallen[m] || 0;
    return t;
  };
  Module.prototype.trede = function (aantal) {
    for (var i = 0; i < this.specs.staffel.length; i++) {
      if (aantal >= this.specs.staffel[i].vanaf) return this.specs.staffel[i];
    }
    return null;
  };
  /**
   * Wat de klant betaalt bij een gegeven korting per stuk. Rekent per maat,
   * want 4XL en 5XL kosten bij Stanley/Stella meer dan S tot 3XL. Zonder
   * ingevulde aantallen valt hij terug op de goedkoopste maat van deze kleur,
   * zodat er altijd een richtprijs staat.
   */
  Module.prototype.prijsBij = function (korting) {
    var totaal = 0, aantal = 0, m, v;
    for (m in this.staat.aantallen) {
      var n = this.staat.aantallen[m] || 0;
      if (!n) continue;
      v = this.variantVoor(this.staat.kleur, m);
      if (!v) continue;
      totaal += n * Math.max(0, v.prijs / 100 - korting);
      aantal += n;
    }
    if (aantal) return { perStuk: totaal / aantal, totaal: totaal, aantal: aantal };
 
    var laagste = null;
    for (var i = 0; i < this.shop.varianten.length; i++) {
      v = this.shop.varianten[i];
      if (this.staat.kleur && v.kleur !== this.staat.kleur.naam) continue;
      if (laagste === null || v.prijs < laagste) laagste = v.prijs;
    }
    if (laagste === null) return null;
    return { perStuk: Math.max(0, laagste / 100 - korting), totaal: 0, aantal: 0 };
  };
  Module.prototype.dpi = function () {
    if (!this.staat.afbeelding || this.staat.vector) return null;
    return Math.round(this.staat.natBreedte / (this.staat.breedteMm / 25.4));
  };
 
  /**
   * Het ijkpunt op de foto: hoeveel pixels gaat er in een millimeter, waar ligt
   * het hart van het artikel, en waar begint de druk?
   *
   * Dit stuk stond eerst binnenin vlak(). Het staat nu apart omdat plaatsing()
   * het ook nodig heeft - die moet weten waar de zak ligt voordat hij zegt hoe
   * hoog er gedrukt mag worden. Let op: hier mag niets uit plaatsing() in,
   * anders bijten de twee elkaar in de staart.
   */
  Module.prototype.basis = function () {
    var k = this.shop.drukvlak;
    var c = this.canvas;
    var kader = (k.auto && this.foto && this.foto.kledingstuk) ? this.foto.kledingstuk : null;
 
    var pxPerMm, basisMiddenX, basisBoven;
    if (kader && kader.lichaam) {
      /* De maatstok: zoveel pixels is zoveel millimeter.
       *
       * Normaal meten we de lichaamsbreedte onderin, waar geen mouwen meer
       * zitten. Maar niet elke packshot ligt zo: bij een hoodie hangen de
       * mouwen langs het lijf tot aan de zoom, en dan meet die band lijf plus
       * twee mouwen.
       *
       * Je ziet het verschil aan het breedste punt van het silhouet. Liggen de
       * mouwen wijd uit, dan zit dat punt bij de mouwuiteinden en is het lijf
       * onderin duidelijk smaller. Hangen ze langs het lijf, dan is die onderste
       * band juist bijna het breedste wat er is - en deugt hij niet als maatstok.
       * Dan ijken we op de schouderbreedte, die bij elk bovenkledingstuk
       * hetzelfde betekent. */
      var lichaamPx = kader.lichaam * c.width;
      var schouderPx = (kader.schouder || 0) * c.width;
      var breedstePx = (kader.breedte || 0) * c.width;
      /* Kennen we de werkelijke breedte van dit artikel - een tote is 380 mm,
         een muts 200 - dan is dat de maatstok. Mouwen spelen daar niet mee. */
      var regel = this.artikelRegel();
      var mouwenLangsLijf = !regel && schouderPx > 0 && lichaamPx > breedstePx * 0.85;
      var maatstokPx = mouwenLangsLijf ? schouderPx : lichaamPx;
      var maatstokMm = regel ? regel.breedteMm
        : (mouwenLangsLijf ? (k.schouderMm || 470) : (k.lichaamMm || 520));
      pxPerMm = maatstokPx / maatstokMm;
      /* Normaal staat de druk in het hart van het artikel en is linksPct een
         fijnregeling uit de thema-instellingen. Op een broek hoort hij op één
         pijp; dan telt de verschuiving uit de artikelregel. */
      var linksPct = (regel && typeof regel.linksPct === 'number') ? regel.linksPct : k.linksPct;
      basisMiddenX = kader.midden * c.width + (linksPct / 100) * maatstokPx;
      // Onze drukker plaatst een frontdruk standaard ca. 170 mm onder het
      // hoogste schouderpunt. Dat punt is de schouderlijn uit meetKledingstuk:
      // bij een shirt de bovenrand, bij een hoodie onder de capuchon.
      var kopFractie = (typeof kader.kop === 'number') ? kader.kop : kader.y;
      if (regel && typeof regel.bovenPct === 'number') {
        /* Gerekend vanaf de bovenkant van het artikel zelf - bij een tas dus
           onder de hengsels - als deel van wat daaronder nog komt. */
        var onderkant = kader.y + kader.hoogte;
        basisBoven = (kopFractie + (onderkant - kopFractie) * regel.bovenPct) * c.height;
      } else {
        basisBoven = kopFractie * c.height + (k.bovenMm || 170) * pxPerMm;
      }
    } else if (kader) {
      var basisB = kader.breedte * c.width * (k.breedtePct / 100);
      pxPerMm = basisB / k.breedteMm;
      basisMiddenX = (kader.x + kader.breedte / 2) * c.width + (k.linksPct / 100) * kader.breedte * c.width;
      basisBoven = (kader.y + kader.hoogte * (k.bovenPct / 100)) * c.height;
    } else {
      /* Niets gemeten. Dan houden we het midden aan - linksPct is een
         verschuiving vanaf het midden, geen linkerrand. Dat ging eerder mis:
         met linksPct 0 kwam het drukvlak op 27,5% van de foto te staan in
         plaats van in het hart. */
      var basisB2 = (k.breedtePct / 100) * c.width;
      pxPerMm = basisB2 / k.breedteMm;
      basisMiddenX = c.width / 2 + (k.linksPct / 100) * c.width;
      basisBoven = (k.bovenPct / 100) * c.height;
    }
    return {
      pxPerMm: pxPerMm,
      middenX: basisMiddenX,
      boven: basisBoven,
      kader: kader
    };
  };

  /** Waar ligt het drukvlak op deze foto, in canvaspixels? */
  Module.prototype.vlak = function () {
    var b = this.basis();
    var p = this.plaatsing();
    return {
      pxPerMm: b.pxPerMm,
      middenX: b.middenX + p.xMm * b.pxPerMm,
      boven: b.boven + p.yMm * b.pxPerMm,
      breedte: p.breedteMm * b.pxPerMm,
      hoogte: p.hoogteMm * b.pxPerMm,
      plaatsing: p
    };
  };

  /** De kenmerken van het artikel uit Shopify, in kleine letters. */
  Module.prototype.kenmerken = function () {
    if (!this._kenmerken) {
      var lijst = this.shop.kenmerken || [];
      this._kenmerken = [];
      for (var i = 0; i < lijst.length; i++) {
        this._kenmerken.push(String(lijst[i]).toLowerCase());
      }
    }
    return this._kenmerken;
  };

  /** Heeft dit artikel een kangoeroezak op het voorpand? */
  Module.prototype.heeftZak = function () {
    var k = this.kenmerken();
    for (var i = 0; i < k.length; i++) {
      if (k[i].indexOf('kangoeroezak') !== -1) return true;
    }
    var soort = String(this.shop.soort || '').trim().toLowerCase();
    return !!soort && ZAK_SOORTEN.indexOf(soort) !== -1;
  };

  /**
   * Zit er een rits over het hele voorpand?
   *
   * Niet bij een tas of een muts: die hebben hun eigen drukvlak uit
   * ARTIKELREGELS, en de rits van een weekendtas zit niet in de weg.
   */
  Module.prototype.heeftRitsVoor = function () {
    if (this.artikelRegel()) return false;
    return heeftVolleRits(this.kenmerken());
  };

  /** Welke plaatsing kiezen we als de huidige niet meer kan? */
  Module.prototype.terugvalPlaatsing = function () {
    return this.heeftRitsVoor() ? 'borst' : 'front';
  };

  /**
   * Zet "Front gecentreerd" uit bij een artikel met een doorlopende rits, en
   * zeg erbij waarom. Dit hangt aan het artikel en niet aan de kleur, dus het
   * hoeft maar één keer.
   */
  Module.prototype.controleerRits = function () {
    var optie = this.keuzePlaatsing && this.keuzePlaatsing.querySelector('option[value="front"]');
    if (!optie) return;
    var rits = this.heeftRitsVoor();
    optie.disabled = rits;
    optie.textContent = rits
      ? 'Front gecentreerd — kan niet, rits middenvoor'
      : 'Front gecentreerd';
    if (rits && this.keuzePlaatsing.value === 'front') {
      this.keuzePlaatsing.value = 'borst';
      this.keuzePlaatsing.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  /**
   * Hoeveel millimeter mag de druk hoog zijn voordat hij de zak raakt?
   *
   * Nul betekent: geen zak in de weg, de gewone maten gelden. We rekenen op de
   * foto: van de onderkant van de druk tot de bovenrand van de zak, min de
   * marge van de drukker. Komt daar een onwerkbaar klein getal uit - bij een
   * foto die niet goed uitgelezen is bijvoorbeeld - dan houden we 60 mm aan en
   * niet minder, zodat er altijd nog iets te ontwerpen valt.
   */
  Module.prototype.zakRuimteMm = function () {
    if (!this.heeftZak()) return 0;
    if (!this.canvas) return 0;
    /* Alleen bij een gecentreerde frontdruk. Een borstdruk zit hoog op het
       lijf en een rugdruk kijkt naar de andere kant. */
    if (!this.keuzePlaatsing || this.keuzePlaatsing.value !== 'front') return 0;
    var b = this.basis();
    var kader = b.kader;
    if (!kader || !b.pxPerMm) return 0;
    var c = this.canvas;
    var kop = ((typeof kader.kop === 'number') ? kader.kop : kader.y) * c.height;
    var zoom = (kader.y + kader.hoogte) * c.height;
    if (!(zoom > kop)) return 0;
    var zakBoven = kop + (zoom - kop) * ZAK_FRACTIE;
    var p = PLAATSINGEN[this.keuzePlaatsing ? this.keuzePlaatsing.value : 'front'] || PLAATSINGEN.front;
    var drukBoven = b.boven + p.yMm * b.pxPerMm;
    var ruimte = (zakBoven - drukBoven) / b.pxPerMm - ZAK_MARGE_MM;
    return Math.max(60, Math.round(ruimte));
  };
 
  /* ------------------------------------------------------------ tekenen --- */
 
  /**
   * Kleur kiezen. Kent de module de varianten van deze kleur nog niet - dat
   * gebeurt bij artikelen met meer dan 250 varianten - dan vraagt hij ze eerst
   * op bij Shopify. Dat duurt een fractie van een seconde en de klant merkt er
   * verder niets van.
   */
  Module.prototype.kiesKleur = function (kleur) {
    var zelf = this;
    if (kleur && kleur.bestelbaar === false && !kleur.geladen) {
      if (kleur.knop) kleur.knop.classList.add('rockland__kleur--laadt');
      this.haalVarianten(kleur, function () {
        if (kleur.knop) kleur.knop.classList.remove('rockland__kleur--laadt');
        zelf.zetKleur(kleur);
      });
      return;
    }
    this.zetKleur(kleur);
  };
 
  /** Vraagt per maat bij Shopify op welke variant bij deze kleur hoort. */
  Module.prototype.haalVarianten = function (kleur, klaar) {
    var zelf = this;
    var maten = this.shop.maatOpties || [];
    if (!this.shop.handle || !kleur.optieId || !maten.length) { kleur.geladen = true; klaar(); return; }
 
    var open = maten.length;
    maten.forEach(function (m) {
      if (!m.id) { af(); return; }
      var adres = '/products/' + zelf.shop.handle
        + '?section_id=rockland-variant&option_values=' + encodeURIComponent(kleur.optieId) + ',' + encodeURIComponent(m.id);
      fetch(adres)
        .then(function (r) { return r.text(); })
        .then(function (tekst) {
          var doc = new DOMParser().parseFromString(tekst, 'text/html');
          var vak = doc.querySelector('[data-rockland-variant]');
          if (!vak) return;
          var v = JSON.parse(vak.textContent);
          if (!v || !v.id) return;
          v.kleur = kleur.naam;
          v.maat = m.naam;
          if (!zelf.variantVoor(kleur, m.naam)) zelf.shop.varianten.push(v);
        })
        .catch(function () { /* stil: dan blijft deze maat gewoon onbekend */ })
        .then(af);
    });
 
    function af() {
      open--;
      if (open > 0) return;
      kleur.geladen = true;
      kleur.bestelbaar = true;
      klaar();
    }
  };
 
  Module.prototype.zetKleur = function (kleur) {
    this.staat.kleur = kleur;
    var knoppen = this.kleurenVak.children;
    for (var i = 0; i < knoppen.length; i++) {
      knoppen[i].setAttribute('aria-pressed', String(this.shop.kleuren[i] === kleur));
    }
    this.toonKleurnaam(null);
    this.stuurThemaAan(kleur);
    this.laadFoto();
    this.controleerRug();
  };
 
  /**
   * Niet van elk artikel bestaat een achterkantfoto. Zolang die er niet is
   * heeft "Rug gecentreerd" geen zin: de klant zou zijn logo op de vóórkant
   * zien staan terwijl er rug staat. Daarom zetten we die keuze uit tot de
   * packshot er wél is. We proberen de bestandsnamen één keer per kleur.
   */
  Module.prototype.controleerRug = function () {
    var zelf = this, k = this.staat.kleur;
    var optie = this.keuzePlaatsing && this.keuzePlaatsing.querySelector('option[value="rug"]');
    if (!optie || !k) return;
 
    if (!this.rugBekend) this.rugBekend = {};
    if (this.rugBekend[k.naam] !== undefined) { zet(this.rugBekend[k.naam]); return; }
 
    var lijst = [];
    if (k.fotoRug) lijst.push(k.fotoRug);
    lijst = lijst.concat(k.bronnenRug || []);
    if (!lijst.length) { this.rugBekend[k.naam] = false; zet(false); return; }
 
    probeer(0);
 
    function probeer(i) {
      if (i >= lijst.length) { zelf.rugBekend[k.naam] = false; zet(false); return; }
      var img = new Image();
      img.onload = function () { zelf.rugBekend[k.naam] = true; zet(true); };
      img.onerror = function () { probeer(i + 1); };
      img.src = lijst[i];
    }
 
    function zet(bestaat) {
      optie.disabled = !bestaat;
      optie.textContent = bestaat
        ? 'Rug gecentreerd'
        : 'Rug gecentreerd — nog geen achterkantfoto';
      if (!bestaat && zelf.keuzePlaatsing.value === 'rug') {
        zelf.keuzePlaatsing.value = zelf.terugvalPlaatsing();
        zelf.keuzePlaatsing.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };
 
  /* --------------------------------------------- koppeling met het thema --- */
 
  /**
   * Op de pagina staan twee kleurkiezers: die van de module en die van het
   * thema. De productfoto's hangen aan die van het thema. Zonder koppeling moet
   * de klant zijn kleur dus twee keer aanklikken — eerst hier, dan nog eens
   * boven bij de foto's. Deze twee functies houden ze gelijk, in beide
   * richtingen. Het vlaggetje voorkomt dat ze elkaar heen en weer blijven
   * aanstoten.
   */
  Module.prototype.themaVelden = function () {
    return document.querySelectorAll(
      'variant-selects input[type="radio"], variant-radios input[type="radio"],' +
      '.product-form__input input[type="radio"], variant-selects select, .product-form__input select'
    );
  };
 
  Module.prototype.stuurThemaAan = function (kleur) {
    if (!kleur || this.negeerThema) return;
    var velden = this.themaVelden(), zelf = this;
    for (var i = 0; i < velden.length; i++) {
      var el = velden[i];
      if (el.tagName === 'SELECT') {
        var raak = false;
        for (var j = 0; j < el.options.length; j++) {
          if ((el.options[j].value || '').trim() === kleur.naam) { raak = true; break; }
        }
        if (!raak || (el.value || '').trim() === kleur.naam) continue;
        this.negeerThema = true;
        el.value = kleur.naam;
      } else {
        if ((el.value || '').trim() !== kleur.naam) continue;
        if (el.checked) return;
        this.negeerThema = true;
        el.checked = true;
      }
      el.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { zelf.negeerThema = false; }, 0);
      return;
    }
  };
 
  Module.prototype.luisterNaarThema = function () {
    var zelf = this;
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || zelf.negeerThema) return;
      if (el.tagName !== 'SELECT' && el.type !== 'radio') return;
      if (zelf.kleurenVak && zelf.kleurenVak.contains(el)) return;
      var waarde = (el.value || '').trim();
      if (!waarde) return;
      if (zelf.staat.kleur && zelf.staat.kleur.naam === waarde) return;
      for (var i = 0; i < zelf.shop.kleuren.length; i++) {
        if (zelf.shop.kleuren[i].naam !== waarde) continue;
        zelf.negeerThema = true;
        zelf.kiesKleur(zelf.shop.kleuren[i]);
        setTimeout(function () { zelf.negeerThema = false; }, 0);
        return;
      }
    });
  };
 
  /** Welke foto's komen in aanmerking voor deze kleur, in volgorde van voorkeur? */
  Module.prototype.bronSleutel = function () {
    var k = this.staat.kleur;
    var rug = this.keuzePlaatsing && this.keuzePlaatsing.value === 'rug';
    return (k ? k.naam : '') + (rug ? '|rug' : '|voor');
  };
 
  Module.prototype.bronnen = function () {
    var k = this.staat.kleur;
    if (!k) return [];
    var sleutel = this.bronSleutel();
    if (this.gekozen[sleutel]) return [this.gekozen[sleutel]];
 
    var lijst = [];
    if (this.keuzePlaatsing && this.keuzePlaatsing.value === 'rug') {
      if (k.fotoRug) lijst.push(k.fotoRug);
      lijst = lijst.concat(k.bronnenRug || []);
    }
    if (k.foto) lijst.push(k.foto);
    lijst = lijst.concat(k.bronnen || []);
    if (k.fallback) lijst.push(k.fallback);
 
    var uniek = [];
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i] && uniek.indexOf(lijst[i]) === -1) uniek.push(lijst[i]);
    }
    return uniek;
  };
 
  /**
   * Laadt de eerste foto uit de lijst die bestaat. Zo kan de packshot uit
   * Bestanden komen zonder dat iemand hem per product hoeft te koppelen: we
   * gokken de naam, en als die niet bestaat pakken we vanzelf de volgende.
   */
  Module.prototype.laadFoto = function () {
    var zelf = this;
    var sleutel = this.bronSleutel();
    var lijst = this.bronnen();
    if (!lijst.length) { this.foto = null; this.werkBij(); return; }
 
    probeer(0, true);
    this.werkBij();
 
    function probeer(i, metCors) {
      if (i >= lijst.length) {
        if (zelf.bronSleutel() === sleutel) { zelf.foto = null; zelf.werkBij(); }
        return;
      }
      var bron = lijst[i];
      if (zelf.fotos[bron]) { klaar(bron, zelf.fotos[bron]); return; }
 
      var img = new Image();
      if (metCors) img.crossOrigin = 'anonymous';
      img.onload = function () {
        var m = zelf.meetKledingstuk(img);
        img.kledingstuk = m.kader;
        img.licht = m.licht;
        zelf.fotos[bron] = img;
        klaar(bron, img);
      };
      img.onerror = function () {
        // sommige servers geven geen toestemming voor uitlezen; dan zonder
        if (metCors) { probeer(i, false); return; }
        probeer(i + 1, true);
      };
      img.src = bron;
    }
 
    function klaar(bron, img) {
      zelf.gekozen[sleutel] = bron;
      if (zelf.bronSleutel() === sleutel) { zelf.foto = img; zelf.werkBij(); }
    }
  };
 
  /**
   * Leest de packshot uit: waar staat het kledingstuk, en hoe licht is de stof?
   * Het kader komt alleen terug bij een transparante achtergrond; de lichtwaarde
   * krijgen we bijna altijd, en die bepaalt de achtergrond en de drukmenging.
   */
  Module.prototype.meetKledingstuk = function (img) {
    var leeg = { kader: null, licht: null };
    try {
      var breed = 160;
      var hoog = Math.max(1, Math.round(breed * (img.naturalHeight / img.naturalWidth)));
      var doek = document.createElement('canvas');
      doek.width = breed; doek.height = hoog;
      var c = doek.getContext('2d', { willReadFrequently: true });
      c.drawImage(img, 0, 0, breed, hoog);
      var d = c.getImageData(0, 0, breed, hoog).data;
 
      var zichtbaar = 0;
      for (var z = 0; z < breed * hoog; z++) if (d[z * 4 + 3] > 24) zichtbaar++;

      /* Geen transparante achtergrond? Dan het silhouet uit de achtergrondkleur
         halen. Zie silhouetUitAchtergrond(). */
      var dekkend = zichtbaar > breed * hoog * 0.97;
      var masker = dekkend ? silhouetUitAchtergrond(d, breed, hoog) : null;
      var hoortErbij = masker
        ? function (p) { return masker[p] === 1; }
        : function (p) { return d[p * 4 + 3] > 24; };

      var minX = breed, minY = hoog, maxX = -1, maxY = -1, telMee = 0;
      var som = 0, geteld = 0;
      var rijen = [];
      for (var y = 0; y < hoog; y++) {
        var ra = breed, rb = -1;
        for (var x = 0; x < breed; x++) {
          if (hoortErbij(y * breed + x)) {
            telMee++;
            if (x < ra) ra = x;
            if (x > rb) rb = x;
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
        rijen.push(rb < 0 ? null : [ra, rb]);
      }
      if (maxX < 0) return leeg;

      /* Mislukt de vulling - een wit artikel op een witte achtergrond - dan is
         het "kledingstuk" bijna de hele foto of bijna niets. Dan geven we geen
         kader terug en valt de module terug op vaste verhoudingen, netjes in
         het midden. Liever een veilige aanname dan een verkeerde meting. */
      var onzeker = !!masker && (telMee > breed * hoog * 0.92 || telMee < breed * hoog * 0.04);
      var vanX = dekkend ? Math.round(breed * 0.35) : minX;
      var totX = dekkend ? Math.round(breed * 0.65) : maxX;
      var vanY = dekkend ? Math.round(hoog * 0.35) : minY;
      var totY = dekkend ? Math.round(hoog * 0.65) : maxY;
 
      for (var y2 = vanY; y2 <= totY; y2++) {
        for (var x2 = vanX; x2 <= totX; x2++) {
          var j = (y2 * breed + x2) * 4;
          if (d[j + 3] < 200) continue;
          som += 0.2126 * d[j] + 0.7152 * d[j + 1] + 0.0722 * d[j + 2];
          geteld++;
        }
      }
 
      /* De breedte van het kledingstuk zelf, dus zonder mouwen. Stanley/Stella
         fotografeert niet alles hetzelfde: bij het ene shirt liggen de mouwen
         wijd uit (het lijf is dan 56% van de foto), bij een sweater liggen ze
         langs het lijf (97%). Daarom meten we het lijf apart, in het onderste
         deel waar geen mouwen meer zitten. Dat is het enige stuk dat bij elk
         artikel hetzelfde betekent - en dus waar we de millimeters op ijken. */
      var bh = maxY - minY + 1;
      var bb = maxX - minX + 1;
      var breedtes = [], middens = [];
      for (var y4 = minY + Math.round(bh * 0.60); y4 <= minY + Math.round(bh * 0.92); y4++) {
        var r = rijen[y4];
        if (!r) continue;
        breedtes.push(r[1] - r[0] + 1);
        middens.push((r[0] + r[1]) / 2);
      }
      var lichaamPx = breedtes.length ? mediaan(breedtes) : bb;
      var middenPx = middens.length ? mediaan(middens) : (minX + maxX) / 2;

      var breedteVanRij = function (y) {
        var r = rijen[y];
        return r ? r[1] - r[0] + 1 : 0;
      };

      /* Waar begint het kledingstuk zelf? Bij een shirt is dat de bovenrand,
         bij een hoodie de schouderlijn onder de capuchon. Zie schouderlijn(). */
      var kopY = schouderlijn(breedteVanRij, minY, maxY, lichaamPx);

      /* De schouderbreedte: mediaan van een smalle band net onder de schouder-
         lijn. Dit is de enige maat die bij élk bovenkledingstuk hetzelfde
         betekent, of de mouwen nu wijd uit liggen of langs het lijf. */
      var schouders = [];
      for (var y6 = kopY; y6 <= Math.min(maxY, kopY + Math.round(bh * 0.08)); y6++) {
        if (rijen[y6]) schouders.push(breedteVanRij(y6));
      }
      var schouderPx = schouders.length ? mediaan(schouders) : lichaamPx;

      return {
        kader: onzeker ? null : {
          x: minX / breed,
          y: minY / hoog,
          breedte: bb / breed,
          hoogte: bh / hoog,
          lichaam: lichaamPx / breed,
          schouder: schouderPx / breed,
          midden: middenPx / breed,
          kop: kopY / hoog
        },
        licht: geteld ? som / geteld : null
      };
    } catch (e) {
      return leeg; // foto van een andere server, niet uit te lezen
    }
  };
 
  /** Hoe licht is de stof? Gemeten uit de foto, anders uit de kleurenlijst. */
  Module.prototype.textielLicht = function () {
    if (this.foto && typeof this.foto.licht === 'number') return this.foto.licht;
    if (this.staat.kleur && this.staat.kleur.donker) return 40;
    return 200;
  };
 
  Module.prototype.donkerTextiel = function () { return this.textielLicht() < 140; };
 
  /**
   * Eén rustige studio-achtergrond voor alles. Alleen bij heel licht textiel
   * (wit, natural) gaan we een tint dieper, anders valt het kledingstuk weg.
   */
  /**
   * Altijd een lichte studio-achtergrond. Bij heel licht textiel (wit, natural)
   * een tint dieper, anders valt het kledingstuk weg tegen de achtergrond.
   * Bewust niet uit de sectie-instellingen: die stonden bij oude installaties
   * nog op donker, en donker willen we hier niet meer.
   */
  Module.prototype.achtergrondKleur = function () {
    return this.textielLicht() > 215 ? '#E4E6E0' : '#F2F2F0';
  };
 
  Module.prototype.teken = function () {
    var c = this.canvas, ctx = this.ctx;
    var achter = this.achtergrondKleur();
    this.podium.style.background = achter;
 
    if (this.foto && this.foto.naturalWidth) {
      if (c.width !== this.foto.naturalWidth || c.height !== this.foto.naturalHeight) {
        c.width = this.foto.naturalWidth;
        c.height = this.foto.naturalHeight;
      }
      // eerst de achtergrond, zodat een transparante packshot ergens op staat
      // en de druk straks netjes mengt met de stof
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = achter;
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(this.foto, 0, 0, c.width, c.height);
    } else {
      ctx.fillStyle = achter;
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.fillStyle = '#8E9691';
      ctx.font = '500 ' + Math.round(c.width * 0.022) + 'px ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.fillText('FOTO LAADT…', c.width / 2, c.height / 2);
    }
 
    var v = this.vlak();
 
    if (this.shop.toonDrukvlak) {
      ctx.save();
      ctx.setLineDash([10, 10]);
      ctx.lineWidth = Math.max(2, c.width * 0.002);
      ctx.strokeStyle = this.donkerTextiel() ? 'rgba(255,255,255,.45)' : 'rgba(0,0,0,.40)';
      ctx.strokeRect(v.middenX - v.breedte / 2, v.boven, v.breedte, v.hoogte);
      ctx.restore();
    }
 
    if (this.staat.afbeelding) {
      var b = this.staat.breedteMm * v.pxPerMm;
      var h = this.hoogteMm() * v.pxPerMm;
      var cx = v.middenX + this.staat.xMm * v.pxPerMm;
      var cy = v.boven + this.staat.yMm * v.pxPerMm;
 
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate((this.staat.rotatie * Math.PI) / 180);
      // op licht textiel mengt de druk met de stof, op donker blijft hij dekkend
      ctx.globalAlpha = 0.96;
      if (!this.donkerTextiel()) ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(this.staat.afbeelding, -b / 2, -h / 2, b, h);
      ctx.restore();
 
      // greep en kader, altijd bovenop
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate((this.staat.rotatie * Math.PI) / 180);
      ctx.strokeStyle = '#D8F227';
      ctx.lineWidth = Math.max(2, c.width * 0.0018);
      ctx.strokeRect(-b / 2, -h / 2, b, h);
      ctx.fillStyle = '#D8F227';
      var r = Math.max(9, c.width * 0.009);
      ctx.fillRect(b / 2 - r, h / 2 - r, r * 2, r * 2);
      ctx.restore();
    }
  };
 
  /* --------------------------------------------------------- interactie --- */
 
  Module.prototype.muisNaarMm = function (e) {
    var r = this.canvas.getBoundingClientRect();
    var schaal = this.canvas.width / r.width;
    var px = (e.clientX - r.left) * schaal;
    var py = (e.clientY - r.top) * schaal;
    var v = this.vlak();
    return { x: (px - v.middenX) / v.pxPerMm, y: (py - v.boven) / v.pxPerMm };
  };
 
  Module.prototype.pakVast = function (e) {
    if (!this.staat.afbeelding) return;
    var m = this.muisNaarMm(e);
    var b = this.staat.breedteMm, h = this.hoogteMm();
    var dx = m.x - this.staat.xMm, dy = m.y - this.staat.yMm;
    var rad = (-this.staat.rotatie * Math.PI) / 180;
    var lx = dx * Math.cos(rad) - dy * Math.sin(rad);
    var ly = dx * Math.sin(rad) + dy * Math.cos(rad);
    var greep = Math.min(b, h) * 0.18 + 6;
 
    if (Math.abs(lx - b / 2) < greep && Math.abs(ly - h / 2) < greep) {
      this.sleep = { soort: 'schalen', startB: b, startD: Math.hypot(lx, ly) || 1 };
    } else if (Math.abs(lx) <= b / 2 && Math.abs(ly) <= h / 2) {
      this.sleep = { soort: 'verplaatsen', dx: dx, dy: dy };
    } else { return; }
    this.canvas.setPointerCapture(e.pointerId);
    this.canvas.classList.add('rockland__canvas--slepen');
  };
 
  Module.prototype.versleep = function (e) {
    if (!this.sleep) return;
    var m = this.muisNaarMm(e);
    if (this.sleep.soort === 'verplaatsen') {
      this.staat.xMm = m.x - this.sleep.dx;
      this.staat.yMm = m.y - this.sleep.dy;
    } else {
      var dx = m.x - this.staat.xMm, dy = m.y - this.staat.yMm;
      var rad = (-this.staat.rotatie * Math.PI) / 180;
      var lx = dx * Math.cos(rad) - dy * Math.sin(rad);
      var ly = dx * Math.sin(rad) + dy * Math.cos(rad);
      var f = Math.hypot(lx, ly) / this.sleep.startD;
      var max = Math.min(this.techniek().maxBreedteMm, this.plaatsing().breedteMm);
      this.staat.breedteMm = Math.max(20, Math.min(max, this.sleep.startB * f));
      this.schuifBreedte.value = Math.round(this.staat.breedteMm);
    }
    this.werkBij();
  };
 
  Module.prototype.laatLos = function (e) {
    if (!this.sleep) return;
    this.sleep = null;
    this.canvas.classList.remove('rockland__canvas--slepen');
    if (e && e.pointerId !== undefined && this.canvas.hasPointerCapture(e.pointerId)) {
      this.canvas.releasePointerCapture(e.pointerId);
    }
  };
 
  Module.prototype.centreer = function () {
    this.staat.xMm = 0;
    this.staat.yMm = this.hoogteMm() / 2 + 20;
    this.werkBij();
  };
 
  Module.prototype.vullend = function () {
    var max = Math.min(this.techniek().maxBreedteMm, this.plaatsing().breedteMm);
    this.staat.breedteMm = max;
    var maxH = Math.min(this.techniek().maxHoogteMm, this.plaatsing().hoogteMm);
    if (this.hoogteMm() > maxH) this.staat.breedteMm = maxH * (this.staat.natBreedte / this.staat.natHoogte);
    this.schuifBreedte.value = Math.round(this.staat.breedteMm);
    this.centreer();
  };
 
  /* ------------------------------------------------------------ bestand --- */
 
  Module.prototype.laadBestand = function (bestand) {
    if (!bestand) return;
    var toegestaan = ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf'];
    if (toegestaan.indexOf(bestand.type) === -1) {
      this.meldingen.innerHTML = '<div class="rockland__melding rockland__melding--blokkerend">' +
        '<strong>Dit bestandstype kunnen we niet gebruiken</strong>Stuur een PDF, SVG, PNG of JPG. ' +
        'Heb je alleen een .ai of .eps? Mail hem naar ons, dan zetten we hem kosteloos om.</div>';
      return;
    }
    var zelf = this, lezer = new FileReader();
    lezer.onload = function () {
      if (bestand.type === 'application/pdf') {
        var doek = document.createElement('canvas');
        doek.width = 900; doek.height = 450;
        var c = doek.getContext('2d');
        c.fillStyle = 'rgba(216,242,39,.18)';
        c.fillRect(0, 0, 900, 450);
        c.strokeStyle = '#7A8A12'; c.lineWidth = 8; c.setLineDash([22, 16]);
        c.strokeRect(4, 4, 892, 442); c.setLineDash([]);
        c.fillStyle = '#3A4406';
        c.font = '700 52px ui-monospace, monospace'; c.textAlign = 'center';
        c.fillText('VECTORBESTAND', 450, 245);
        var v = new Image();
        v.onload = function () { zelf.zet(v, bestand, true, 900, 450); };
        v.src = doek.toDataURL();
        return;
      }
      var img = new Image();
      img.onload = function () {
        zelf.zet(img, bestand, bestand.type === 'image/svg+xml',
          img.naturalWidth || 1000, img.naturalHeight || 1000);
      };
      img.onerror = function () {
        zelf.meldingen.innerHTML = '<div class="rockland__melding rockland__melding--blokkerend">' +
          '<strong>Dit bestand konden we niet openen</strong>Sla het opnieuw op en probeer het nog eens.</div>';
      };
      img.src = lezer.result;
    };
    lezer.readAsDataURL(bestand);
  };
 
  Module.prototype.zet = function (img, bestand, vector, b, h) {
    this.staat.afbeelding = img;
    this.staat.bestand = bestand;
    this.staat.vector = vector;
    this.staat.natBreedte = b;
    this.staat.natHoogte = h;
    this.staat.rotatie = 0;
    this.schuifRotatie.value = 0;
    this.uitRotatie.textContent = '0°';
    this.staat.breedteMm = Math.min(this.plaatsing().breedteMm * 0.55, this.techniek().maxBreedteMm);
    this.schuifBreedte.value = Math.round(this.staat.breedteMm);
    this.bestandsnaam.textContent = bestand.name;
    this.centreer();
  };
 
  /* ---------------------------------------------------------- bijwerken --- */
 
  Module.prototype.werkBij = function () {
    var zelf = this;
    var techniek = this.techniek();
    var plaatsing = this.plaatsing();
 
    this.schuifBreedte.max = Math.min(techniek.maxBreedteMm, plaatsing.breedteMm);
    if (this.staat.breedteMm > Number(this.schuifBreedte.max)) {
      this.staat.breedteMm = Number(this.schuifBreedte.max);
      this.schuifBreedte.value = this.staat.breedteMm;
    }
    this.uitBreedte.textContent = Math.round(this.staat.breedteMm) + ' mm';
    this.uitRotatie.textContent = this.staat.rotatie + '°';
 
    this.teken();
 
    // voorraad per maat
    this.shop.maten.forEach(function (maat) {
      var el = zelf.matenVak.querySelector('[data-voorraad="' + maat + '"]');
      var invoer = zelf.matenVak.querySelector('[data-maat="' + maat + '"]');
      var variant = zelf.variantVoor(zelf.staat.kleur, maat);
      if (!el || !invoer) return;
      /* Voorraadaantallen naast elke maat maken het scherm onrustig, en bij
         Stanley/Stella staan er toch duizenden. We tonen ze alleen als de
         winkelier daarom vraagt; een maat die niet leverbaar is blijft wel
         zichtbaar, want dat moet de klant weten. */
      var toon = zelf.shop.toonVoorraad === true;
      if (!variant) {
        el.textContent = toon ? '—' : 'niet leverbaar';
        el.className = 'rockland__voorraad rockland__voorraad--leeg';
        invoer.value = 0; invoer.disabled = true;
        zelf.staat.aantallen[maat] = 0;
      } else if (variant.voorraadBeheerd && variant.voorraad <= 0) {
        el.textContent = 'uitverkocht';
        el.className = 'rockland__voorraad rockland__voorraad--leeg';
        invoer.value = 0; invoer.disabled = true;
        zelf.staat.aantallen[maat] = 0;
      } else {
        invoer.disabled = false;
        if (!toon) {
          el.textContent = '';
          el.className = 'rockland__voorraad';
        } else if (!variant.voorraadBeheerd) {
          el.textContent = 'op voorraad';
          el.className = 'rockland__voorraad';
        } else {
          el.textContent = variant.voorraad + ' st';
          el.className = 'rockland__voorraad' +
            (variant.voorraad < 50 ? ' rockland__voorraad--laag' : '');
        }
      }
    });
 
    var aantal = this.totaal();
    var trede = this.trede(aantal);
 
    // maatvoering over de foto
    var chips = [];
    if (this.staat.kleur) chips.push('<span>' + this.staat.kleur.naam + '</span>');
    if (this.staat.afbeelding) {
      chips.push('<span class="rockland--hi">' + Math.round(this.staat.breedteMm) + ' × ' + Math.round(this.hoogteMm()) + ' mm</span>');
      chips.push('<span>' + (this.staat.vector ? 'vector' : this.dpi() + ' dpi') + '</span>');
    } else {
      chips.push('<span>nog geen logo</span>');
    }
    this.meting.innerHTML = chips.join('');
 
    // prijs
    var nu = this.prijsBij(trede ? trede.korting : 0);
    this.uitAantal.textContent = aantal;
    this.uitPerStuk.textContent = nu ? euro(nu.perStuk) : '—';
    this.uitTotaal.textContent = euro(nu ? nu.totaal : 0);
 
    var rijen = '';
    for (var i = this.specs.staffel.length - 1; i >= 0; i--) {
      var t = this.specs.staffel[i], hoger = this.specs.staffel[i - 1];
      var p = this.prijsBij(t.korting);
      rijen += '<tr class="' + (trede && trede.vanaf === t.vanaf ? 'rockland--actief' : '') + '"><td>' +
        (hoger ? t.vanaf + '–' + (hoger.vanaf - 1) : t.vanaf + '+') + ' stuks</td><td>' +
        (p ? euro(p.perStuk) : '—') + '</td></tr>';
    }
    this.tredesVak.innerHTML = rijen;
 
    var uitslag = this.controleer(aantal);
    this.meldingen.innerHTML = uitslag.html;
    this.knop.disabled = !uitslag.mag;
  };
 
  Module.prototype.controleer = function (aantal) {
    var techniek = this.techniek(), plaatsing = this.plaatsing();
    var lijst = [], mag = true;
 
    if (!this.staat.afbeelding) {
      return { mag: false, html: '<div class="rockland__melding"><strong>Upload je logo</strong>' +
        'Vector (PDF, SVG) is het scherpst. PNG of JPG mag ook, als de resolutie het toelaat.</div>' };
    }
 
    var hoogte = this.hoogteMm();
    var rad = Math.abs((this.staat.rotatie * Math.PI) / 180);
    var omB = Math.abs(this.staat.breedteMm * Math.cos(rad)) + Math.abs(hoogte * Math.sin(rad));
    var omH = Math.abs(this.staat.breedteMm * Math.sin(rad)) + Math.abs(hoogte * Math.cos(rad));
 
    var maxHoogte = Math.min(techniek.maxHoogteMm, plaatsing.hoogteMm);
    if (hoogte > maxHoogte) {
      mag = false;
      if (plaatsing.doorZak && maxHoogte === plaatsing.hoogteMm) {
        lijst.push(['blokkerend', 'Te hoog: de zak zit in de weg',
          'Op dit model loopt de kangoeroezak over het voorpand. Daar kan niet' +
          ' overheen gedrukt worden - de naad geeft een vouw in de inkt. Tot' +
          ' aan de zak is ' + maxHoogte + ' mm hoog mogelijk.']);
      } else {
        lijst.push(['blokkerend', 'Te hoog voor ' + techniek.naam.toLowerCase(),
          'Maximaal ' + maxHoogte + ' mm hoog. Maak de druk kleiner.']);
      }
    } else if (
      this.staat.xMm - omB / 2 < -plaatsing.breedteMm / 2 - 0.5 ||
      this.staat.xMm + omB / 2 > plaatsing.breedteMm / 2 + 0.5 ||
      this.staat.yMm - omH / 2 < -0.5 ||
      this.staat.yMm + omH / 2 > plaatsing.hoogteMm + 0.5
    ) {
      mag = false;
      lijst.push(['blokkerend', 'Buiten het drukvlak',
        'Sleep je logo terug binnen de stippellijn.']);
    }
 
    if (this.heeftRitsVoor()) {
      lijst.push(['let-op', 'Rits middenvoor',
        'Dit model heeft een rits over het hele voorpand. Daar kan geen druk' +
        ' overheen. Je kunt kiezen uit een borstdruk naast de rits of een druk' +
        ' op de rug.']);
    }

    /* Uitleg waarom het vlak op dit model korter is dan op een shirt. Niet
       blokkerend - het staat er zodat niemand denkt dat de module iets mist. */
    if (plaatsing.doorZak) {
      lijst.push(['let-op', 'Drukvlak stopt boven de zak',
        'Dit model heeft een kangoeroezak. De druk blijft er twee centimeter' +
        ' boven, anders loopt de naad onder de pers door. Daardoor is het vlak' +
        ' hier ' + plaatsing.hoogteMm + ' mm hoog in plaats van ' +
        (PLAATSINGEN[this.keuzePlaatsing.value] || PLAATSINGEN.front).hoogteMm + ' mm.']);
    }

    /* Boven ongeveer A4 rekent onze drukker niet op tarief maar op aanvraag.
       Geen blokkade: elke order komt toch langs onze artwork-goedkeuring. */
    var oppervlakCm2 = (this.staat.breedteMm * this.hoogteMm()) / 100;
    if (oppervlakCm2 > MAX_OPPERVLAK_CM2) {
      lijst.push(['let-op', 'Grote druk: ' + Math.round(oppervlakCm2) + ' cm²',
        'Boven 500 cm² geeft onze drukker een prijs op aanvraag. Je kunt gewoon bestellen — wij nemen contact op voordat we drukken.']);
    }

    if (!this.staat.vector) {
      var d = this.dpi();
      if (d < this.specs.minDpi) {
        mag = false;
        var maxMm = Math.max(10, Math.floor(this.staat.natBreedte / this.specs.minDpi * 25.4));
        lijst.push(['blokkerend', 'Te lage resolutie: ' + d + ' dpi',
          'Dit bestand blijft scherp tot ongeveer ' + maxMm + ' mm breed; je staat nu op ' + Math.round(this.staat.breedteMm) + ' mm. Maak de druk kleiner, of upload je logo als PDF of SVG — dan vervalt deze grens. Heb je alleen een .ai of .eps? Mail hem naar ons, dan zetten we hem kosteloos om.']);
      } else if (d < 300) {
        lijst.push(['let-op', 'Bruikbaar: ' + d + ' dpi', 'Vector of 300 dpi geeft een scherpere rand.']);
      }
    }
 
    if (this.staat.voorraadgrens) {
      lijst.push(['let-op', 'Maat ' + this.staat.voorraadgrens.maat + ': nog ' +
        this.staat.voorraadgrens.aantal + ' leverbaar',
        'Meer nodig? Mail ons — vaak kunnen we bijbestellen bij Stanley/Stella.']);
    }
 
    if (aantal === 0) {
      mag = false;
      lijst.push(['let-op', 'Vul de aantallen in', 'Verdeel vrij over de maten.']);
    } else if (aantal < techniek.minAantal) {
      /* Blokkerend, niet als waarschuwing: anders legt iemand 15 stuks in de
         winkelwagen, rekent af, en moeten wij achteraf bellen dat het niet kan. */
      mag = false;
      lijst.push(['blokkerend',
        'Nog ' + (techniek.minAantal - aantal) + ' stuks tot het minimum van ' + techniek.minAantal,
        'Je hebt er nu ' + aantal + '. Het minimum geldt voor de hele drukopdracht, niet per maat — ' +
        'je mag ze vrij over de maten verdelen. Kleinere oplage nodig? Mail ons, dan maken we een offerte ' +
        'met ' + euro(this.specs.insteltarief) + ' insteltarief.']);
    } else if (mag) {
      var volgende = null;
      for (var i = 0; i < this.specs.staffel.length; i++) {
        if (this.specs.staffel[i].vanaf > aantal && (!volgende || this.specs.staffel[i].vanaf < volgende.vanaf)) {
          volgende = this.specs.staffel[i];
        }
      }
      var straks = volgende ? this.prijsBij(volgende.korting) : null;
      lijst.push(['goed', 'Klaar om te bestellen', straks
        ? 'Nog ' + (volgende.vanaf - aantal) + ' stuks erbij en de prijs zakt naar ' + euro(straks.perStuk) + ' per stuk.'
        : 'Je zit in de scherpste prijstrede.']);
    }
 
    return {
      mag: mag,
      html: lijst.map(function (m) {
        return '<div class="rockland__melding rockland__melding--' + m[0] + '"><strong>' + m[1] + '</strong>' + m[2] + '</div>';
      }).join('')
    };
  };
 
  /* ------------------------------------------------- opslaan en cart --- */
 
  /**
   * De hexcode van het gekozen kleurvlakje. Die kleur is al uit de packshot
   * gemeten door verfVlakje(); we lezen hem hier terug in plaats van ergens
   * een tweede kleurenlijst bij te houden. De printservice tekent de drukproef
   * ermee - zonder deze waarde valt hij terug op bijna-zwart.
   */
  Module.prototype.kleurHex = function () {
    if (!this.kleurenVak || !this.staat.kleur) return null;
    var knoppen = this.kleurenVak.children;
    for (var i = 0; i < knoppen.length; i++) {
      if (this.shop.kleuren[i] !== this.staat.kleur) continue;
      var achter = window.getComputedStyle(knoppen[i]).backgroundColor;
      var m = achter && achter.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
      /* geen kleur, of doorzichtig: dan staat er een foto op het vlakje */
      if (!m) return null;
      if (m[4] !== undefined && Number(m[4]) === 0) return null;
      var hex = '#';
      for (var k = 1; k <= 3; k++) hex += ('0' + Number(m[k]).toString(16)).slice(-2);
      return hex.toUpperCase();
    }
    return null;
  };
 
  Module.prototype.bewaarOntwerp = function () {
    var gegevens = {
      artikelcode: this.shop.artikelcode,
      kleur: { naam: this.staat.kleur.naam, donker: this.donkerTextiel(), hex: this.kleurHex() },
      techniek: this.techniekCode(),
      keuze: this.keuzeTechniek.value,
      /* De catalogusprijs (25-stuksprijs), gewogen over de ingevulde maten.
         De printservice trekt daar de staffelkorting van af; zo rekenen winkel
         en dossier met hetzelfde bedrag. */
      catalogusPrijs: (function (p) { return p ? Math.round(p.perStuk * 100) / 100 : null; })(this.prijsBij(0)),
      plaatsing: this.keuzePlaatsing.value,
      drukkleur: this.staat.drukkleur || null,
      druk: {
        breedteMm: Math.round(this.staat.breedteMm * 10) / 10,
        hoogteMm: Math.round(this.hoogteMm() * 10) / 10,
        offsetXMm: Math.round(this.staat.xMm * 10) / 10,
        offsetYMm: Math.round(this.staat.yMm * 10) / 10,
        rotatie: this.staat.rotatie
      },
      aantallen: this.staat.aantallen,
      klant: this.shop.klant || {}
    };
    var form = new FormData();
    form.append('bestand', this.staat.bestand);
    form.append('gegevens', JSON.stringify(gegevens));
 
    return fetch(this.shop.proxy + '/api/ontwerpen', { method: 'POST', body: form })
      .then(function (a) {
        return a.json().then(function (body) {
          if (!a.ok) throw new Error(body.fout || 'Opslaan mislukt');
          return body;
        });
      });
  };
 
  Module.prototype.voegToe = function () {
    if (this.bezig) return;
    var zelf = this, plaatsing = this.plaatsing(), techniek = this.techniek();
    this.bezig = true;
    this.wortel.classList.add('rockland__bezig');
    var oud = this.knop.textContent;
    this.knop.textContent = 'Bezig…';
 
    this.bewaarOntwerp()
      .then(function (ontwerp) {
        var regels = [];
        zelf.shop.maten.forEach(function (maat) {
          var n = zelf.staat.aantallen[maat] || 0;
          if (!n) return;
          var variant = zelf.variantVoor(zelf.staat.kleur, maat);
          if (!variant) return;
          regels.push({
            id: variant.id,
            quantity: n,
            properties: {
              _ontwerp: ontwerp.id,
              Druk: techniek.naam + ', ' + plaatsing.naam.toLowerCase() + ', ' +
                Math.round(zelf.staat.breedteMm) + ' × ' + Math.round(zelf.hoogteMm()) + ' mm',
              Drukkleur: zelf.staat.drukkleur || (techniek.naam === 'Zeefdruk' ? 'nog vast te leggen' : '—'),
              Drukproef: (String(zelf.shop.proxy).indexOf('http') === 0 ? '' : window.location.origin) +
                zelf.shop.proxy + '/api/ontwerpen/' + ontwerp.id + '/proef.png'
            }
          });
        });
        if (!regels.length) throw new Error('Geen maten ingevuld');
 
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: regels })
        }).then(function (a) {
          return a.json().then(function (b) {
            if (!a.ok) throw new Error(b.description || b.message || 'Toevoegen mislukt');
            return b;
          });
        });
      })
      .then(function () {
        zelf.knop.textContent = 'Toegevoegd';
        document.dispatchEvent(new CustomEvent('rockland:toegevoegd'));
        if (zelf.shop.naarWinkelwagen) window.location.href = '/cart';
        else setTimeout(function () { zelf.knop.textContent = oud; }, 2500);
      })
      .catch(function (fout) {
        zelf.meldingen.innerHTML = '<div class="rockland__melding rockland__melding--blokkerend">' +
          '<strong>Er ging iets mis</strong>' + fout.message + ' Probeer het nog eens, of mail ons — we helpen je meteen.</div>';
        zelf.knop.textContent = oud;
      })
      .finally(function () {
        zelf.bezig = false;
        zelf.wortel.classList.remove('rockland__bezig');
      });
  };
 
  /* ------------------------------------------------------------ starten --- */
 
  /**
   * Eén plek om te kiezen, niet twee.
   *
   * De productpagina van het thema heeft zelf ook kleur, maat en aantal staan,
   * bovenaan, nog vóór de ontwerpmodule. De knop "In winkelwagen" is daar
   * weggehaald - dus die velden doen niets. Wie er zijn maat en zijn aantal
   * invult en dan naar beneden scrolt, denkt dat hij al iets besteld heeft en
   * begint onderin opnieuw. Dat voelt niet logisch, en terecht.
   *
   * Daarom halen we die keuzevelden weg zodra de module op de pagina staat.
   * De titel, de prijs, de omschrijving en de foto's blijven; alleen de
   * keuzes verdwijnen, want die horen in de module thuis. We verbergen ze en
   * halen ze niet weg: het thema praat er zelf nog mee, en een verborgen veld
   * blijft gewoon werken.
   */
  function verbergDubbeleKeuzes() {
    var weg = document.querySelectorAll(
      'variant-selects, variant-radios, .product-form__quantity');
    for (var i = 0; i < weg.length; i++) {
      var el = weg[i];
      if (el.closest && el.closest('[data-rockland]')) continue;
      el.style.display = 'none';
    }
  }

  function start() {
    var gevonden = false;
    document.querySelectorAll('[data-rockland]').forEach(function (el) {
      if (!el.rocklandModule) el.rocklandModule = new Module(el);
      gevonden = true;
    });
    if (gevonden) verbergDubbeleKeuzes();
  }
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
 